module.exports = __webpack_public_path__ + "img/discountType@2x.967eb62f.png";